<template>
  <div class="page">
    <div :class="['box', isShow ? ['box-show', type] : '']">
      {{ msg }}
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import _ from "lodash";

// 提示类型，与背景样式相对应
export const TOAST_TYPE = {
  SUCCESS: "success",
  WARN: "warn",
  ERROR: "error",
};

export default {
  components: {},
  watch: {},
  setup() {
    const isShow = ref(false);
    const msg = ref("");
    const type = ref("");
    return { isShow, msg, type };
  },
};
</script>

<style lang="less" scoped>
.page {
  .box {
    position: fixed;
    top: 80px;
    left: 0;
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: #ffffff;
    font-size: 20px;
    font-weight: 500;
    font-family: "PingFang SC";
    background-size: 100% 100%;
    display: none;
    z-index: 9999;

    &-show {
      display: initial;
    }
  }

  .warn {
    background: linear-gradient(
      90deg,
      transparent 0%,
      #c9a355 50%,
      transparent 100%
    );
  }

  .error {
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(209, 85, 85, 1) 50%,
      transparent 100%
    );
  }

  .success {
    background: linear-gradient(
      90deg,
      transparent 0%,
      #158e90 50%,
      transparent 100%
    );
  }

  @media screen and (max-width: 765px) {
    .box {
      position: fixed;
      top: 212px;
      left: 0;
      height: auto;
      font-size: 14px;
      line-height: 32px;
    }
  }

  @media only screen and (min-width: 520px) and (max-width: 765px) {
    .box {
      position: fixed;
      top: 212px;
      left: 0;
      height: 67px;
      font-size: 14px;
      line-height: 67px;
    }
  }
}
</style>
